import { render, staticRenderFns } from "./JourneyGroup.vue?vue&type=template&id=3014d99a&scoped=true&"
import script from "./JourneyGroup.vue?vue&type=script&lang=js&"
export * from "./JourneyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3014d99a",
  null
  
)

export default component.exports